import React from 'react';
import './Contact.css';

function Contact() {
  // Sostituisci con il tuo numero WhatsApp Business (formato internazionale senza + e spazi)
  const whatsappNumber = "41787184245"; // Svizzera
  const whatsappMessage = "Ciao Alessandro! Vorrei informazioni sulle lezioni di italiano.";
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <section className="contact">
      <div className="contact-content">
        <h2>Prenota subito una lezione!</h2>
        <p className="contact-subtitle">Mettiamoci in contatto!</p>
        <p>Usa il link qui sotto per il mio profilo di WhatsApp Business.</p>
        
        <a 
          href={whatsappLink}
          target="_blank" 
          rel="noopener noreferrer" 
          className="cta-button whatsapp-button"
        >
          <span className="whatsapp-icon">💬</span>
          Contattami su WhatsApp
        </a>
        
        <div className="blog-link">
          <p>Vuoi approfondire argomenti di italiano?</p>
          <a href="https://blog.ripetizioniitaliano.com" target="_blank" rel="noopener noreferrer" className="blog-button">
            Visita il Blog
          </a>
        </div>
      </div>
    </section>
  );
}

export default Contact;
